import React from 'react';
import ReactDOM from 'react-dom';
import './css/style.css';
import App from './App';
import { ThemeContextProvider } from './store/theme-context';

ReactDOM.render(<ThemeContextProvider><App /></ThemeContextProvider>,document.getElementById('root'));


